import Connector from '../../agent';

export interface CompetencyInfo {
  isMissingCompetency: boolean;
  awarenessExpiryDate: string | null;
  handlingExpiryDate: string | null;
}

export type CompetencyInfoMap = Record<number, CompetencyInfo>;

export const fetchCompetencyInfo = async (personIds: number[]): Promise<CompetencyInfoMap> => {
  if (!personIds || personIds.length === 0) {
    return {};
  }
  try {
    const result = await Connector.api.get('/persons/competency-info', false, {
      personIds: personIds.join(','),
    });
    return result.data as CompetencyInfoMap;
  } catch (error) {
    console.error('Failed to fetch competency info', error);
    return {};
  }
};
